module.exports = __webpack_public_path__ + "d48ec2131bcd3d4eea64db358d81a8ee.jpg";